import PropTypes from 'prop-types';

export const LOAD = 'FEATURE_TOGGLES_LOAD';
export const LOAD_START = 'FEATURE_TOGGLES_LOAD_START';
export const LOAD_SUCCESS = 'FEATURE_TOGGLES_LOAD_SUCCESS';
export const LOAD_FAIL = 'FEATURE_TOGGLES_LOAD_FAIL';

export const featureToggleMapPropType = PropTypes.shape({});
export function load() {
  return {
    type: LOAD,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/feature-toggles',
      method: 'get',
    },
  };
}
